export default "__VITE_ASSET__c8b9decd__"